export class EmailContainerController {
    /* @ngInject */
    constructor(accountCreationHelpService, userSessionService, destinationService, $stateParams, $state, $log) {
        this.accountCreationHelpService = accountCreationHelpService;
        this.userSessionService = userSessionService;
        this.destinationService = destinationService;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$log = $log;
    }

    $onInit() {
        this.state = this.$stateParams.state;
        this.username = this.$stateParams.username;
        this.popup = this.$stateParams.popup;

        this.user = {};
        this.twoFactorEnabled = this.destinationOrganization.securityConfiguration.twoFactorEnabled;

        if (this.userSessions.length == 1) {
            this.user = this.userSessions[0];
        }

        this.emailTaken = false;
        this.edit = this.state === 'EDIT';
    }

    verifyEmail() {
        this.$state.go('activate.verify', {
            state: this.state,
            email: this.email,
            username: this.username,
            popup: this.popup
        }, {
            reload: true
        });
    }

    activateWithoutEmail() {
        this.accountCreationHelpService.handleActivationNavigation(this.twoFactorEnabled, this.username, this.user, null);
    }
}

export let EmailContainerComponent = {
    controller: EmailContainerController,
    controllerAs: 'vm',
    templateUrl: 'app/login/email/EmailContainerComponent.html',
    bindings: {
        destinationOrganization: '<',
        userSessions: '<'
    }
};